import type { ComponentChildren } from "preact";

export function Chip({ children }: { children: ComponentChildren }) {
  return <span class="chip">{children}</span>;
}

interface ChipsProps {
  items?: string[] | string | null;
}

export function Chips({ items }: ChipsProps) {
  if (!Array.isArray(items)) {
    if (items == null || items === "") return <span>—</span>;
    return <Chip>{items}</Chip>;
  }
  if (items.length === 0) return <span>—</span>;
  return (
    <>
      {items.map((v, i) => <Chip key={`${v}-${i}`}>{v}</Chip>)}
    </>
  );
}
